import React, { useState } from 'react';
import { Button } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import DialogTitle from '@mui/material/DialogTitle';
import { Font,PDFDownloadLink } from "@react-pdf/renderer";
import Slide from '@mui/material/Slide';
// import ReactDOM from 'react-dom/client';
import KPeeLogo from '../LogoKPee1.png';


  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const FormatedDateNoTime = ({value}) => {
    const timestamp = value;
    const date = new Date(timestamp);
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    const formattedDate = `${year}-${month}-${day}`;
    return <Text>{formattedDate}</Text>;
  }



const LoanAdviseCommodity = ({Loan_Details, More_Details, Transaction_Details, Repayment_Schedule, Amount_Total, Interest_Total, Total_Khraa}) => {
    const [open, setOpen] = useState(true);
    const handleclose = () => {
        setOpen(false);
    };

    const formatCurrency = (amount, currencyCode = 'GHS') => {
      // Format the currency using toLocaleString with options
      return amount.toLocaleString('en-GH', {
        style: 'currency',
        currency: currencyCode,
      });
    };

    const styles = StyleSheet.create({
        body: {
          margin: 0,
          paddingLeft: 45,
          paddingRight: 45,
          paddingTop: 10,
        },
        header: {
          fontSize: 10,
          marginBottom: 20,
          textAlign: 'center',
          color: 'grey',
        },
        section: {
          flexDirection: 'row',
          padding:0,
          marginBottom:20
        },
        sectionn: {
          flexDirection: 'row',
          padding:0,
          marginBottom:20
        },
        sec1: {
          flex: 1,
          margin: 5,
          paddingLeft:0,
          paddingRight:50,
          fontSize:10
        },
        logo: {
          flex: 1,
          maxWidth: 60,
          height: 50,
          paddingLeft:0,
          border: '1px outset brown',
          marginRight:180,
          marginBottom:5
        },
        sec2: {
          flex: 1,
          margin: 5,
          marginLeft:90,
          paddingRight:0,
          textAlign: 'left',
          fontSize:10,
          color:'#805b10'
        },
        sec21: {
          flex: 1,
          margin: 5,
          marginLeft:90,
          paddingRight:0,
          textAlign: 'justify',
          fontSize:10
        },
        title: {
          textAlign: 'center',
          textDecoration:'underline'
        },
        salutation: {
          fontSize:10,
          marginBottom:10,
          marginTop:10,
          textAlign: 'left',
        },
        message: {
          fontSize:10,
          fontWeight: 'bold',
          textAlign: 'justify',
        },
        end: {
          color: 'brown',
          fontSize:10,
          fontWeight: 'bold',
          textAlign: 'left',
          marginTop: 6
        },
        important: {
          fontFamily: 'Roboto',
          fontWeight: 900,
          fontSize: 10,
        },
        sec1color: {
          color: '#064F80'
        },
        table: {
          display: 'table',
          width: 'auto',
          borderStyle: 'solid',
          borderWidth: 1,
          borderRightWidth: 0,
          borderBottomWidth: 0,
          marginTop: 5,
          marginBottom: 20,
          borderRadius:2,
          color:'gray'
        },
        tableRow: {
          margin: 'auto',
          flexDirection: 'row',
          color:'black'
        },
        tableCol: {
          width: '50%',
          borderStyle: 'solid',
          borderWidth: 1,
          borderLeftWidth: 0,
          borderTopWidth: 0,
        },
        tableCol1: {
          width: '25%',
          borderStyle: 'solid',
          borderWidth: 1,
          borderLeftWidth: 0,
          borderTopWidth: 0,
        },
        tableCell: {
          margin: 'auto',
          marginTop: 5,
          fontSize: 10,
          textAlign: 'left',
          paddingBottom: 2,
          color:'black'
        },
        tableCelll: {
          fontSize: 10,
          padding: 5,
          color:'black'
        },
        charge: {
          color: 'brown',
          fontSize: 9,
          fontWeight: '200',
          textAlign: 'left',
          marginTop: 10,
        },
        repaymentS: {
          fontSize:12,
        },
        bold: {
          fontWeight: 'semibold',
          fontWeight: '200',
          color: '#14213d'
        },
        pageNumber: {
          position: 'absolute',
          fontSize: 12,
          bottom: 30,
          left: 0,
          right: 0,
          textAlign: 'center',
          color: 'grey',
        },
       });
       

       const MyLoanAdvise = () => (
        <Document>
        <Page size="A4" style={styles.body}>
          <Text style={styles.header} fixed>
            ~ The Cooperative ~
          </Text>
          <View style={styles.section}>
              <Image src={KPeeLogo} alt='KPee logo' style={styles.logo} />
              {
                More_Details?.community_name?
                  <Text style={styles.sec2}>
                    SOCIETY: <Text style={styles.bold}>{More_Details?.society}</Text>{'\n'}
                    CLUSTER: <Text style={styles.bold}>{More_Details?.cluster_name}</Text>{'\n'}
                    COMMUNITY: <Text style={styles.bold}>{More_Details?.community_name}</Text>{'\n'}
                    SAVINGS GROUP: <Text style={styles.bold}>{More_Details.association_name}</Text>{'\n'}
                    WAREHOUSE: <Text style={styles.bold}>{More_Details?.warehouse}</Text>{'\n'}
                    PASSBOOK NO.: <Text style={styles.bold}>{More_Details.passbook_id}</Text>{'\n'}
                    Issue Date: <Text style={styles.bold}>{<FormatedDateNoTime value={Loan_Details.issue_date} />}</Text>{'\n'}
                  </Text>
                  :
                  <Text style={styles.sec2}>
                    SAVINGS GROUP: <Text style={styles.bold}>{More_Details.association_name}</Text>{'\n'}
                    WAREHOUSE: <Text style={styles.bold}>{More_Details?.warehouse}</Text>{'\n'}
                    PASSBOOK NO.: <Text style={styles.bold}>{More_Details.passbook_id}</Text>{'\n'}
                    Issue Date: <Text style={styles.bold}>{<FormatedDateNoTime value={Loan_Details.issue_date} />}</Text>{'\n'}
                  </Text>
              }
                 
          </View>
    
          <View style={styles.section}>
              <Text style={styles.sec1}>
              <Text style={styles.sec1color}>From:</Text>{'\n'}
                KIBBUTZ PISHON CO-OPERATIVE{'\n'}
                MUTUAL SUPPORT AND SOCIAL{'\n'}
                SERVICES LIMITED{'\n'}
                P. O. BOX 424, TECHIMAN B/E{'\n'}
                COMMUNITY: {More_Details.community_name} {'\n'}
                CLUSTER: {More_Details.cluster_name}
              </Text>
              <Text style={styles.sec21}>
            <Text style={styles.sec1color}>To:</Text>{'\n'}
            {`${More_Details.firstname} ${More_Details?.middlename} ${More_Details.lastname}`}{'\n'}
            {More_Details.address}{'\n'}
            Next of Kin: {More_Details.nextOfKin}
            </Text>
          </View>
          <Text style={styles.title}>Loan Advise Letter</Text>
          <Text style={styles.salutation}>Dear Mrs/Mr. {`${More_Details.firstname} ${More_Details.lastname}`}, </Text>
     
          <Text style={styles.message}>
            We have approved your request for {More_Details?.warehouse} loan of <Text style={styles.important}>GHS{Transaction_Details.recommended_amount? Transaction_Details.recommended_amount.toFixed(2): Transaction_Details.amount.toFixed(2)}</Text>. 
             Which an amount of <Text style={styles.important}>GHS{Transaction_Details.amount.toFixed(2)}</Text> was initially requested (i.e {Transaction_Details?.percent.toFixed(2)}% of your commodity cash value). 
            This loan has been approved for a period of <Text style={styles.important}>{Loan_Details.period}</Text> with an interest rate 
            of <Text style={styles.important}>{Loan_Details.interest_rate_percentage.toFixed(2)}%</Text>, amounting to <Text style={styles.important}>GHS{Loan_Details.interest_rate_amount.toFixed(2)}</Text>. 
            Your repayment schedule will commence on  <Text style={styles.important}>{<FormatedDateNoTime value={Loan_Details.repayment_starting_date} />} </Text> 
             and conclude on <Text style={styles.important}>{<FormatedDateNoTime value={Loan_Details.repayment_ending_date} />}</Text>.
          </Text>
          <Text style={styles.charge}>
            Charges are automatically deducted from Cooperative savings account
          </Text>
    
          <View style={styles.table}> 
            <View style={styles.tableRow}> 
              <View style={styles.tableCol}> 
                <Text style={styles.tableCell}>Charges</Text> 
              </View> 
              <View style={styles.tableCol}> 
                <Text style={styles.tableCell}>Amount</Text> 
              </View>
            </View>
            <View style={styles.tableRow}> 
              <View style={styles.tableCol}> 
                <Text style={styles.tableCelll}>Loan Application Fee ({More_Details.application_fee}%)</Text> 
              </View> 
              <View style={styles.tableCol}> 
                <Text style={styles.tableCelll}>GHS{Loan_Details.application_fee.toFixed(2)}</Text> 
              </View> 
            </View>
            <View style={styles.tableRow}> 
              <View style={styles.tableCol}> 
                <Text style={styles.tableCelll}>Loan Processing Fee ({More_Details.proccessing_fee}%)</Text> 
              </View> 
              <View style={styles.tableCol}> 
                <Text style={styles.tableCelll}>GHS{Loan_Details.proccessing_fee.toFixed(2)} </Text> 
              </View> 
            </View>
            <View style={styles.tableRow}> 
              <View style={styles.tableCol}> 
                <Text style={styles.tableCelll}>Total</Text> 
              </View> 
              <View style={styles.tableCol}> 
                <Text style={styles.tableCelll}>GHS{(Loan_Details.application_fee + Loan_Details.proccessing_fee).toFixed(2)} </Text> 
              </View> 
            </View>
          </View>
    
          <Text style={styles.repaymentS}>
                Repayment Schedule 
          </Text>
    
          <View style={styles.table}> 
            <View style={styles.tableRow}> 
              <View style={styles.tableCol1}> 
                <Text style={styles.tableCell}>Repayment Date</Text> 
              </View> 
              <View style={styles.tableCol1}> 
                <Text style={styles.tableCell}>Principal Amount</Text> 
              </View>
              <View style={styles.tableCol1}> 
                <Text style={styles.tableCell}>Interest Amount</Text> 
              </View>
              <View style={styles.tableCol1}> 
                <Text style={styles.tableCell}>Total Repayment</Text> 
              </View>
            </View>
            {
              Repayment_Schedule.map((item) => (
                <View style={styles.tableRow}> 
                  <View style={styles.tableCol1}> 
                    <Text style={styles.tableCelll}>{item.Date}</Text> 
                  </View> 
                  <View style={styles.tableCol1}> 
                    <Text style={styles.tableCelll}>GHS{item.Amount_to_be_Paid.toFixed(2)}</Text> 
                  </View>
                  <View style={styles.tableCol1}> 
                    <Text style={styles.tableCelll}>GHS{item.Interest_Amount.toFixed(2)}</Text> 
                  </View>
                  <View style={styles.tableCol1}> 
                    <Text style={styles.tableCelll}>{(item.Amount_to_be_Paid + item.Interest_Amount).toFixed(2)}</Text> 
                  </View>
                </View>
              ))
            }
                <View style={styles.tableRow}> 
                  <View style={styles.tableCol1}> 
                    <Text style={styles.tableCelll}><Text style={styles.important}>Total GHS</Text></Text> 
                  </View>
    
                  <View style={styles.tableCol1}> 
                    <Text style={styles.tableCelll}>{Amount_Total.toFixed(2)}</Text> 
                  </View>
                  <View style={styles.tableCol1}> 
                    <Text style={styles.tableCelll}>{Interest_Total.toFixed(2)}</Text> 
                  </View>
                  <View style={styles.tableCol1}> 
                    <Text style={styles.tableCelll}>{Total_Khraa.toFixed(2)}</Text> 
                  </View>
                </View>
            
            
          </View>
          
          <Text style={styles.end}>
            Report any issue regarding the loan to our office or call: 0244815594.
          </Text>
        </Page>
      </Document>
      );
      Font.register({
        family: 'Roboto',
        src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-800.ttf',
        fontWeight: 800,
      });
    
      return(
        <>
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleclose}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>{"Loan Advise"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Loan Advise Generated Successfully.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleclose} variant='contained' color='success' sx={{ marginRight:1 }}>Close</Button>
              {/* <Button onClick={handleView}>View</Button> */}
              <PDFDownloadLink document={<MyLoanAdvise />} filename="FORM">
                  {({loading}) => (loading ?  <Button variant='contained' color='success'>Loading...</Button> :  <Button variant='contained' color='success'>Download</Button> )}
              </PDFDownloadLink>
             
            </DialogActions>
          </Dialog>
        </>
      )

};
export default LoanAdviseCommodity;